<div>
    <div class="metadataSelectContainer">
        <label for="from" class="metadataLabel">Request type: </label>
        <div class="w-100 d-flex justify-content-start">
            <p-dropdown
                    [styleClass]="'standardDropdownStyle drop-down group-details-inp drop-admin'"
                    placeholder="Select Request Type"
                    [options]="requestTypeList"
                    [(ngModel)]="selectRequestType"
                    (onChange)="onRequestTypeChange($event.value)"
                    [ngClass]="{'standardDropdownStyle-open': isDropdownOpen}" (onShow)="isDropdownOpen = true"
                    (onHide)="isDropdownOpen = false">
            </p-dropdown>
        </div>
    </div>

    <div *ngIf="showPicklist" class="p-2">
        <p-pickList
            [source]="availableRootCauses"
            [target]="selectedRootCauses"
            [showSourceControls]="false"
            [showTargetControls]="false"
            sourceHeader="{{srcHeader}}"
            targetHeader="{{targetHeader}}"
            [responsive]="true"
            dragdrop="true"
            [sourceStyle]="{'height':'300px'}"
            [targetStyle]="{'height':'300px'}">
            <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix">
                    <span>{{item}}</span>
                </div>
            </ng-template>
        </p-pickList>
    </div>
    <div *ngIf="showPicklist" class="metadata-footer">
        <button pButton label="Cancel" class="cancel-button" (click)="resetForm()"></button>
        <button pButton label="Save" class="submit-button" (click)="onApply(currentRequestType)"></button>
    </div>
    <div *ngIf="isApplied" class="d-flex justify-content-center">
        <span class="msg">Changes are applied for (<strong>{{currentRequestType}}</strong>)</span>
    </div>
</div>
